export const defaultFilterHeight = 45;
export const defaultFilterWidth = 200;
export const defaultCellWidth = 130;
export const defaultTooltipPosition = 'right';
